import {
  IQuickVideo,
  IQuickVideoPartPositionOption,
  IQuickVideoPartTestSendForm,
  IQuickVideoTestSendForm,
} from 'lib/api/quickVideo/types';
import { ICombinedUserData } from 'lib/context';

export const getQuickVideoTestSendInitialValues = ({
  userData,
  quickVideo,
  positions,
}: {
  userData: ICombinedUserData;
  quickVideo: IQuickVideo;
  positions: IQuickVideoPartPositionOption[];
}) => {
  const quickVideoParts: IQuickVideoPartTestSendForm[] = positions.map(vpd => ({
    partPosition: vpd.value,
    partType: '',
    video: null,
    quickVideoPartId: 0,
    description: '',
  }));

  quickVideoParts.forEach((part, index) => {
    const matchingProvidedPart = (quickVideo.quickVideoParts || []).find(
      p => p.partPosition === part.partPosition
    );
    if (!!matchingProvidedPart) {
      const userConfigs =
        matchingProvidedPart?.quickVideoPartUserConfigurations;
      const customerConfig =
        matchingProvidedPart?.quickVideoPartCustomerConfiguration;

      const hasUserConfigurations = !!userConfigs && userConfigs.length > 0;

      quickVideoParts[index] = {
        quickVideoPartId: matchingProvidedPart.quickVideoPartId,
        partPosition: matchingProvidedPart.partPosition,
        partType: matchingProvidedPart.partType,
        description: matchingProvidedPart.description || '',
        video:
          customerConfig?.video ||
          (hasUserConfigurations && userConfigs[0]?.video) ||
          null,
      };
    }
  });

  return {
    recipientEmail: `${userData.email}           ${userData.phone1}` || '',
    recipientName: '',
    inventoryItemId: 0,
    quickVideoParts,
  } satisfies IQuickVideoTestSendForm;
};
